/**
 * SA-1329 (spec §4.4): the queue judges a selection from each thread's own
 * detail, read at the press, never from what the list served.
 */
import { apiClient } from '@/services/apiClient'
import { transformDetail } from '@/hooks/useInbox'
import type { InboxConversationDetail } from '@/types/inbox'

/** One detail read per distinct id, in parallel; a failed read rejects the lot. */
export async function readTriageDetails(
  conversationIds: readonly string[],
): Promise<Map<string, InboxConversationDetail>> {
  const ids = [...new Set(conversationIds)]
  const details = await Promise.all(ids.map(async (id) => {
    const response = await apiClient.fetch(`/api/inbox/conversations/${id}`)
    if (!response.ok) throw new Error(`Failed to fetch conversation: ${response.statusText}`)
    return transformDetail(await response.json())
  }))
  return new Map(ids.map((id, i) => [id, details[i]]))
}
